import React, { useContext } from "react";
import GettingStartedContext from "../utils/GettingStartedContext";

const ExcerptSection = () => {
    const { showResult, langString, getProperty } = useContext(
        GettingStartedContext
    );

    if (!showResult) {
        return null;
    }

    return (
        <div className="gsa__excerpt" id="details-section">
            <div className="grid-container grid-container--gsa">
                <div className="grid-x">
                    <div className="small-12">
                        <h3>{langString("THE_PERFECT_OPTION")}</h3>
                        <p>{getProperty("ExcerptDescription")}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExcerptSection;
